export default __webpack_public_path__ + "static/media/conteudo_extra_11_23.14ae69e6.jpg";